import axios from 'axios';
import store from '../store/store'
import {v4 as UUIDService} from 'uuid';

const url = '/api/v1/external/folders';

class FolderService {
    
    static addFolders(folders, token) {
        
        return axios.post(url, {
            data: folders
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static deleteFoldersByOwner(ownerId, token) {
        
        return axios.delete(url + '/byOwner/' + ownerId, {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }
    
    static getFolders(ownerId, activeOnly, token) {
        
        let localUrl = url + "/" + ownerId

        if(!activeOnly) {
            localUrl += "/all"
        }

        return axios.get(localUrl, {
            headers: {Authorization: `Bearer ${token}`}
        })

    }

    static updateFolders(folders, token) {
        
        return axios.put(url, {
            data: folders
        }, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }
}

export default FolderService; 